$('#subscribe-form').on('submit', function(e) {
	const voucher = $('[name="discount_code"]').val().trim();

	if (voucher.length) {
		e.preventDefault();

		$.post('/buy-credits/check-voucher/', { voucher_code: voucher }, function(res) {
			if (res.status !== 'success') {
				alert('The voucher code entered is not valid.');
			} else {
				$('#subscribe-form')[0].submit();
			}
		}, 'json');
	}
});